module.exports = __webpack_public_path__ + "media/vid1.14b2a94b.mp4";